export default __webpack_public_path__ + "static/media/panTech3.65b817ad.png";